import Plotly from 'plotly.js-dist-min';
import * as _ from 'lodash';

const dateRangeRegex = /^\d{4}-\d{2}-\d{2}-\d{4}-\d{2}-\d{2}$/;
const getFilterdData = (graphData, primaryKpi) => {
  if (10 > graphData.length) {
    return graphData;
  }
  return graphData
    .slice()
    .sort((a, b) => {
      return b[primaryKpi] - a[primaryKpi];
    })
    .slice(0, 10);
};
const replaceString = '?*?';
const colorArray = [
  '#2077b4',
  '#ff7f0f',
  '#2da02d',
  '#d62828',
  '#9467bd',
  '#8c564c',
  '#e377c3',
  '#7f7f7f',
  '#bcbd21',
  '#16becf',
  '#2077b4',
  '#ff69b4',
  '#00ced1',
  '#ff6347',
  '#8a2be2',
  '#32cd32',
  '#ff4500',
  '#7b68ee',
  '#9acd32',
  '#ba55d3',
  '#f08080',
  '#4682b4',
  '#ffa07a',
  '#40e0d0',
  '#d2b48c',
  '#5f9ea0',
  '#ff8c00',
  '#8b008b',
  '#ff1493',
  '#00bfff',
  '#696969',
  '#bc8f8f',
  '#483d8b',
  '#2e8b57',
  '#8b4513',
  '#8b0000',
  '#9370db',
  '#6a5acd',
  '#00fa9a',
  '#00ff7f',
];

const configOptions = {
  editable: false,
  displaylogo: false,
  displayModeBar: false,
  scrollZoom: false,
  showLink: false,
  modeBarButtonsToRemove: [
    'sendDataToCloud',
    'zoom2d',
    'pan',
    'pan2d',
    'autoScale2d',
    'lasso2d',
    'autoScale2d',
    'resetScale2d',
    'toggleSpikelines',
    'dragmode',
  ],
};
function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
function getTheKeys(key) {
  let result = '';
  if (!isJson(key)) {
    result = key;
  } else {
    if (Array.isArray(JSON?.parse(key))) {
      let val = JSON?.parse(key);
      result = val?.length > 0 ? val.join(',') : val?.length <= 0 ? 'N/A' : val;
    } else {
      let data = JSON?.parse(key);
      let objKeys = Object.keys(data);
      if (objKeys?.length > 0) {
        objKeys.forEach(k => {
          data[k] = data[k]?.length ? data[k] : 'N/A';
          result = result !== '' ? `${result}, ${k}: ${data[k]}` : `${k}: ${data[k]}`;
        });
      } else {
        result = 'N/A';
      }
    }
  }
  return result;
}
export const generateSocialResultGraph = ({ breakDown, kpiList, primaryKpi, currency,fromSS }) => {
  let lastValue = breakDown?.groups[Object.keys(breakDown?.groups).pop()];
  let graphData = lastValue[0]?.graphData;
  if (lastValue[0]?.level === 1) {
    let rslt = getFilterdData(lastValue[0]?.graphData, primaryKpi);
    graphData = rslt;
  }
  let formattedDataForGraph = {};
  for (let record of graphData) {
    let { breakdownId, ...kpis } = record;
    if (!breakdownId.includes('unknown') && !breakdownId.includes('Unknown')) {
      for (let kpi in kpis) {
        let newArray = [kpi].concat(breakdownId);
        newArray = newArray.map(x => {
          let key = getTheKeys(x);
          if(key.includes('.')) {
            key = key.replaceAll('.', replaceString);
          }
          return key;
        });
        _.set(formattedDataForGraph, newArray.join('.'), kpis[kpi]);
      }
    }
  }
  formattedDataForGraph = JSON.parse(JSON.stringify(formattedDataForGraph).replaceAll(replaceString,'.'));
  const traceFormate = {
    x: [],
    y: [],
    type: 'bar',
    xaxis: '',
    barmode: 'group',
    textposition: 'auto',
    // opacity: 0.8,
    width: 0.1,
  };
  let singleTrace = {
    x: [],
    y: [],
    width: 0.2,
    opacity: 0.5,
    type: 'bar',
    tickwidth: '5px',
    marker: {
      color: '#20779d',
    },
  };
  const defaultLayout = {
    title: '',
    barmode: 'group',
    width: '750',
    autosize: true,
    legend: {
      orientation: 'h',
      xanchor: 'center',
      yanchor: 'bottom',
      y: 0.9,
      x: 1.02,
    },
  };
  const changeMetricsName = key => {
    const metric = kpiList?.filter(x => x?.sys_id === key)[0];
    let data_type = metric?.data_type;
    let type = '';
    if (data_type === 'PERCENTAGE') {
      type = '(%) ';
    } else if (data_type === 'CURRENCY') {
      type = `(${currency}) `;
    }
    return type ? type + metric?.KPI_Metric : metric?.KPI_Metric;
  };
  let labelArr = {
    parent: [],
    child: [],
    subchild: [],
  };
  Object.keys(formattedDataForGraph).forEach((el, index) => {
    let threeLevelTraces = [];
    let layout = JSON.parse(JSON.stringify(defaultLayout));
    layout.title = {
      text: changeMetricsName(el),
      y: 0.97,
      yanchor: 'bottom',
    };
    let isOnelevel = false;
    let legendgroup = [];

    Object.keys(formattedDataForGraph[el]).forEach((parent, parentIndex) => {
      const isDateRange = dateRangeRegex.test(parent) ? true : false;
      if (!isDateRange || parentIndex < 8) {
        let startDomain, endDomain;
        if (isDateRange) {
          startDomain = parentIndex / 8;
          const gap = 1 / 8;
          endDomain = parentIndex / 8 + gap;
        } else {
          startDomain = parentIndex / Object.keys(formattedDataForGraph[el]).length;
          const gap = 1 / Object.keys(formattedDataForGraph[el]).length;
          endDomain = parentIndex / Object.keys(formattedDataForGraph[el]).length + gap;
        }
        if (
          formattedDataForGraph[el][parent] &&
          Object.keys(formattedDataForGraph[el][parent])?.length > 0
        ) {
          isOnelevel = false;
          layout['xaxis' + (parentIndex + 1)] = {
            domain: [startDomain, endDomain],
            anchor: 'x' + (parentIndex + 1),
            title: {
              text: parentIndex === 4 ? lastValue[0]?.groupAttributes[1] : '',
              automargin: true,
              // standoff: 200
            },
            tickangle: 0,
          };
          Object.keys(formattedDataForGraph[el][parent]).forEach((child, childIndex) => {
            let trace = JSON.parse(JSON.stringify(traceFormate));
            trace.xaxis = 'x' + (parentIndex + 1);
            trace.x = [];
            trace.y = [];
            trace.name = parent;
            // trace.legendgroup = parent;
            if (
              formattedDataForGraph[el][parent][child] &&
              Object.keys(formattedDataForGraph[el][parent][child])?.length > 0
            ) {
              trace.name = child ? child : 'N/A';
              if (legendgroup.includes(child)) {
                const index = legendgroup.findIndex(ele => ele === child);
                trace.marker = { color: colorArray[index] ? colorArray[index] : colorArray[2] };
                trace.showlegend = false;
              } else {
                trace.showlegend = true;
                let pushedIndex = legendgroup.push(child) - 1;
                trace.marker = {
                  color: colorArray[pushedIndex] ? colorArray[pushedIndex] : colorArray[2],
                };
              }
              const legendIndex = legendgroup.findIndex(ele => ele === child);
              trace.legendgroup = legendgroup[legendIndex];
              if (!labelArr.parent.includes(parent.substring(0, 5) + '..  : ' + parent)) {
                labelArr.parent.push(parent.substring(0, 5) + '..  : ' + parent);
              }
              Object.keys(formattedDataForGraph[el][parent][child]).forEach(
                (subchild, subchildIndex) => {
                  layout['xaxis' + (parentIndex + 1)].title = {
                    text: parent.substring(0, 5) + '...',
                  };
                  layout.legend.y = 1;
                  layout.legend.x = 0.5;
                  trace['hovertemplate'] =
                    parent +
                    ' | ' +
                    subchild +
                    ' | ' +
                    formattedDataForGraph[el][parent][child][subchild];
                  trace.x.push(subchild ? subchild.substring(0, 5) + '...' : 'N/A');
                  if (!labelArr.subchild.includes(subchild.substring(0, 5) + '..  : ' + subchild)) {
                    labelArr.subchild.push(subchild.substring(0, 5) + '..  : ' + subchild);
                  }
                  // trace.x.push(subchild ? subchild.match(rxpForMultilayer).join("<br>") : 'N/A');
                  trace.y.push(formattedDataForGraph[el][parent][child][subchild]);
                }
              );
            } else {
              trace.marker = {
                color: colorArray[parentIndex] ? colorArray[parentIndex] : colorArray[2],
              };
              trace['hovertemplate'] = child + ' | ' + formattedDataForGraph[el][parent][child];
              trace.x.push(child.substring(0, 2) + '..');
              if (!labelArr.child.includes(child.substring(0, 2) + '..  : ' + child)) {
                labelArr.child.push(child.substring(0, 2) + '..  : ' + child);
              }
              //  trace.x.push(child.match(rxp2layer).join("<br>"));
              if (childIndex === 0) {
                trace.showlegend = true;
              } else {
                trace.showlegend = false;
              }
              layout.legend.y = 1;
              layout.legend.x = 0.5;
              trace.y.push(formattedDataForGraph[el][parent][child]);
            }
            threeLevelTraces.push(trace);
          });
        } else {
          isOnelevel = true;
          let trace = JSON.parse(JSON.stringify(singleTrace));
          //  trace.x.push(parent.match(rxpForaxis).join("<br>"));
          trace.x.push(parent);
          if (!labelArr.parent.includes(parent)) {
            labelArr.parent.push(parent);
          }
          trace['hovertemplate'] = parent + ' | ' + formattedDataForGraph[el][parent];
          trace.y.push(formattedDataForGraph[el][parent]);
          trace.name = parent;
          trace.showlegend = false;
          layout.showLegend = false;
          threeLevelTraces.push(trace);
        }
      }
    });
    let node = 'social' + breakDown.id + (index + 1);
    let element = document.createElement('div');
    element.id = node;
    if (isOnelevel) {
      layout['xaxis'] = {
        automargin: true,
        tickangle: 0,
        title: {
          text: lastValue[0]?.groupAttributes[0],
          // standoff: 500
        },
        tickmode: 'array',
      };
      const arr = threeLevelTraces.map(trace => trace?.x[0]);
      layout['xaxis']['tickvals'] = arr;
      layout['xaxis']['ticktext'] = arr.map(x => (x?.length > 5 ? x.substring(0, 5) + '...' : x));
    }
    layout['yaxis'] = {
      automargin: true,
      title: {
        text: layout.title?.text,
      },
    };
    document.getElementById('social' + breakDown.id)?.appendChild(element);
    Plotly.newPlot(node, threeLevelTraces, layout, configOptions, { responsive: true });
    if(fromSS) {
      let ssNode = 'socialss' + breakDown.id + (index + 1);
      let ssele = document.createElement('div');
      ssele.id = ssNode;
      document.getElementById('socialss' + breakDown.id)?.appendChild(ssele);
      Plotly.newPlot(ssNode, threeLevelTraces, layout, configOptions, { responsive: true });
    }
  });
  let labelEl = document.getElementById('label' + breakDown.id);
  labelEl.innerHTML =
    labelArr.parent.map(elx => '<p>' + elx + '</p>').join('') +
    labelArr.child.map(elx => '<p>' + elx + '</p>').join('') +
    labelArr.subchild.map(elx => '<p>' + elx + '</p>').join('');
};
